module.exports = __webpack_public_path__ + "static/media/instagram.b0415f60.svg";